import classes from './tooltip.module.css'

const Tooltip = {
  classNames: {
    tooltip: classes.tooltip,
  },
}

export default Tooltip
